import {useEffect} from 'react';
import {StyleSheet, View} from 'react-native';
import {Button, Text} from 'react-native-paper';
import {useLinkTo} from '@react-navigation/native';
import auth from '@react-native-firebase/auth';

import {useAppSettings} from './AppSettings';
import {useAuthPersonInfo} from '../hooks/usePersonInfo';

export const NotFound = () => {
  const user = auth().currentUser;
  const appSettings = useAppSettings();
  const authUserInfo = useAuthPersonInfo();
  const linkTo = useLinkTo();

  useEffect(() => {
    if (authUserInfo?.isAdmin || authUserInfo?.isGuestRelations) {
      linkTo('/search');
    } else {
      linkTo('/investor');
    }
  });

  return (
    <View style={styles.detailsContainer}>
      <Text style={styles.sectionTitle}>
        {appSettings.t('PageNotFoundText')}
      </Text>
      <View style={styles.spacer} />
      <Button
        onPress={() => {
          if (user) {
            linkTo('/');
          } else {
            linkTo('/account/login');
          }
        }}>
        {appSettings.t('home')}
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  detailsContainer: {
    flex: 1,
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 24,
  },
  sectionTitle: {
    fontSize: 24,
    fontWeight: '600',
  },
  spacer: {
    height: 20,
  },
});
